"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeQuickactions_de_de = void 0;
function backofficeQuickactions_de_de() {
    return {
        "backoffice.quickactions.notloggedin": "Bitte melden Sie sich zuerst an oder erstellen Sie einen Account und wiederholen Sie die Aktion.",
        "backoffice.quickactions.unknown.title": "Unbekannte Aktion",
        "backoffice.quickactions.unknown.message": "Dieser Link scheint kaputt zu sein. Bitte melden Sie sich bei unserem Support, falls der Fehler nochmals auftritt.",
        "backoffice.quickactions.book.title": "Abonnement buchen",
        "backoffice.quickactions.book.message": "Sie werden nun zu Ihrem Projekt weitergeleitet, um die Buchung abzuschließen...",
        "backoffice.quickactions.book.noprojectfound": "Kein Projekt gefunden. Bitte erstellen Sie ein Projekt und schließen Sie die Buchung anschließend ab.",
        "backoffice.quickactions.redirect": "Sie werden in 5 Sekunden auf das Cloud Dashboard weitergeleitet...",
        "backoffice.quickactions.optin.title": "Opt-In bestätigen",
        "backoffice.quickactions.optin.loading": "Ihre gewünschte Eintragung wird bearbeitet...",
        "backoffice.quickactions.optin.done": "Sie haben sich erfolgreich in unsere Liste eingetragen.",
        "backoffice.quickactions.optout.title": "Opt-Out bestätigen",
        "backoffice.quickactions.optout.loading": "Ihre gewünschte Austragung wird bearbeitet...",
        "backoffice.quickactions.optout.done": "Sie haben sich erfolgreich aus unserer Liste ausgetragen."
    };
}
exports.backofficeQuickactions_de_de = backofficeQuickactions_de_de;
